export const GET_STORE_CONFIGURATION_BEGIN = 'GET_STORE_CONFIGURATION_BEGIN';
export const GET_STORE_CONFIGURATION_SUCCESS =
  'GET_STORE_CONFIGURATION_SUCCESS';
export const GET_STORE_CONFIGURATION_FAIL = 'GET_STORE_CONFIGURATION_FAIL';
